<template>
  <div class="user-detail-refund-group-orders">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="userDetailRefundGroupOrdersInfo.orders" border style="width: 100%">
        <el-table-column prop="returnId" :label="$t('userDetailRefundGroupOrders.refundId')" align="center">
        </el-table-column>
        <el-table-column prop="orderId" :label="$t('userDetailRefundGroupOrders.order')" align="center">
        </el-table-column>
        <el-table-column prop="prodName" :label="$t('userDetailRefundGroupOrders.product')" align="center">
        </el-table-column>
        <el-table-column prop="buyerName" :label="$t('userDetailRefundGroupOrders.buyer')" align="center">
        </el-table-column>
        <el-table-column prop="buyerCount" :label="$t('userDetailRefundGroupOrders.buyQuantity')" align="center">
        </el-table-column>
        <el-table-column prop="groupPrice" :label="$t('userDetailRefundGroupOrders.groupPrice')" align="center">
        </el-table-column>
        <el-table-column prop="returnMoney" :label="$t('userDetailRefundGroupOrders.refundAmount')" align="center">
        </el-table-column>
        <el-table-column prop="returnType" :label="$t('userDetailRefundGroupOrders.refundType')" align="center">
          <template slot-scope="scope">
            {{ scope.row.returnType === '1001' ? $t('userDetailRefundGroupOrders.selfRefund') :
              $t('userDetailRefundGroupOrders.groupFailedRefund') }}
          </template>
        </el-table-column>
        <el-table-column prop="reason" :label="$t('userDetailRefundGroupOrders.refundReason')" align="center">
        </el-table-column>
        <el-table-column prop="state" :label="$t('userDetailRefundGroupOrders.status')" align="center">
        </el-table-column>
        <el-table-column prop="stateMsg" :label="$t('userDetailRefundGroupOrders.reviewNote')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getRefundGroupOrderList } from '@/api/user/userDetailRefundGroupOrdersApi'

export default {
  name: 'UserDetailRefundGroupOrders',
  data() {
    return {
      userDetailRefundGroupOrdersInfo: {
        orders: [],
        buyerId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailRefundGroupOrdersInfo.buyerId = data.userId
      this.loadRefundGroupOrderData()
    },
    loadRefundGroupOrderData() {
      const params = {
        buyerId: this.userDetailRefundGroupOrdersInfo.buyerId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getRefundGroupOrderList(params).then(res => {
        this.userDetailRefundGroupOrdersInfo.orders = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadRefundGroupOrderData()
    }
  }
}
</script>

<style scoped>
.user-detail-refund-group-orders {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>